import {
  Dropdown as BaseDropdown,
  DropdownPassThroughOptions,
  DropdownProps as BaseDropdownProps,
} from 'primereact/dropdown';
import { FC } from 'react';
import S from './Dropdown.module.scss';

const pt: DropdownPassThroughOptions = {
  panel: {
    className: S.dropdownPanel,
  },
};

type DropdownProps = BaseDropdownProps;
export const Dropdown: FC<DropdownProps> = (props) => {
  return <BaseDropdown {...props} pt={pt} />;
};
